import { getUserByUsername } from "../api";
import { useApiGet } from "@/hooks/useApi";

export function useGetUserByUsername(username) {
	const { data, isPending, isSuccess, isError, error } = useApiGet({
		key: ["users", `${username}`],
		fn: () => getUserByUsername(username),
	});

	const { user } = data || { user: [] };

	return { user, isPending, isSuccess, isError, error };
}
